export const COUNTRIES = [
    { code: "us", label: "United States", languageCode: "en", locationCode: 2840 },
    { code: "gb", label: "United Kingdom", languageCode: "en", locationCode: 2826 },
    { code: "se", label: "Sweden", languageCode: "sv", locationCode: 2752 },
    { code: "de", label: "Germany", languageCode: "de", locationCode: 2276 },
    { code: "fr", label: "France", languageCode: "fr", locationCode: 2250 },
    { code: "es", label: "Spain", languageCode: "es", locationCode: 2724 },
    { code: "it", label: "Italy", languageCode: "it", locationCode: 2380 },
    { code: "nl", label: "Netherlands", languageCode: "nl", locationCode: 2528 },
    { code: "no", label: "Norway", languageCode: "no", locationCode: 2578 },
    { code: "dk", label: "Denmark", languageCode: "da", locationCode: 2208 },
    { code: "fi", label: "Finland", languageCode: "fi", locationCode: 2246 },
    { code: "pt", label: "Portugal", languageCode: "pt", locationCode: 2620 },
    { code: "br", label: "Brazil", languageCode: "pt", locationCode: 2076 },
    { code: "au", label: "Australia", languageCode: "en", locationCode: 2036 },
    { code: "ca", label: "Canada", languageCode: "en", locationCode: 2124 },
    { code: "in", label: "India", languageCode: "en", locationCode: 2356 },
    { code: "jp", label: "Japan", languageCode: "ja", locationCode: 2392 },
    { code: "kr", label: "South Korea", languageCode: "ko", locationCode: 2410 },
    { code: "pl", label: "Poland", languageCode: "pl", locationCode: 2616 },
    { code: "at", label: "Austria", languageCode: "de", locationCode: 2040 },
    { code: "ch", label: "Switzerland", languageCode: "de", locationCode: 2756 },
];
const COUNTRY_MAP = new Map(COUNTRIES.map((c) => [c.code, c]));
const US_COUNTRY = {
    code: "us",
    label: "United States",
    languageCode: "en",
    locationCode: 2840,
};
const TLD_TO_COUNTRY = new Map([...COUNTRIES.map((c) => [c.code, c.code]), ["uk", "gb"]]);
const SECOND_LEVEL_TLDS = new Map([
    ["co.uk", "gb"],
    ["com.au", "au"],
    ["co.jp", "jp"],
    ["co.kr", "kr"],
    ["com.br", "br"],
    ["co.in", "in"],
]);
export function countryFromDomain(domain) {
    const clean = domain.replace(/^www\./, "").toLowerCase();
    for (const [sld, code] of SECOND_LEVEL_TLDS) {
        if (clean.endsWith(`.${sld}`))
            return code;
    }
    const tld = clean.split(".").pop() ?? "";
    return TLD_TO_COUNTRY.get(tld) ?? "us";
}
export function getCountry(code) {
    return COUNTRY_MAP.get(code) ?? US_COUNTRY;
}
